"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _context = _interopRequireDefault(require("./context"));

var _buttonReset = _interopRequireDefault(require("./../_styles/button-reset"));

var _focus = _interopRequireDefault(require("../_focus"));

var _token = require("./../_utils/token");

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _text = _interopRequireDefault(require("./../_styles/text"));

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var _borderRadius = _interopRequireDefault(require("./../_utils/border-radius"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Helpers
 */
var transparent = "rgba(0,0,0,0)";
var keysThatMoveFocus = ["ArrowLeft", "ArrowRight", "Home", "End"];
/**
 * Styles
 */
// Root styles

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled,
      fill = _ref.fill,
      type = _ref.type,
      selectedIndex = _ref.selectedIndex,
      focus = _ref.focus;
  return (0, _emotion.css)(_buttonReset["default"], (0, _text["default"])(t), {
    flexGrow: fill === "tabs" ? 1 : "initial",
    position: "relative",
    ":not(:last-child)": {
      marginInlineEnd: t("spacingHorizontal")
    },
    cursor: disabled ? "not-allowed" : "pointer",
    transition: t.transitionCss("motion", "color"),
    color: t("foregroundColor", disabled ? "disabled" : selected ? "selected" : "default"),
    textAlign: "center",
    padding: "".concat(t("spacingInsetVertical"), "px ").concat(t("spacingInsetHorizontal"), "px"),
    marginBottom: t("indicatorHeight") + t("spacingVertical", type),
    ":hover": !disabled && !selected && {
      color: t("foregroundColorHover")
    },
    ":active": !disabled && {
      color: t("foregroundColorPressed")
    }
  }, type === "classic" ? classicStyles(t, {
    selected: selected,
    disabled: disabled,
    selectedIndex: selectedIndex
  }) : {}, !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: type === "classic" ? -8 : 0
  }) : undefined);
}, ["selected", "disabled", "fill", "type", "selectedIndex", "focus"]);

var classicStyles = function classicStyles(t, _ref2) {
  var _ref3;

  var disabled = _ref2.disabled,
      selectedIndex = _ref2.selectedIndex;
  return _ref3 = {
    boxSizing: "border-box",
    border: "".concat(t("borderWidth"), "px solid ").concat(t("borderColor")),
    borderColor: "".concat(transparent, " ").concat(transparent, " ").concat(t("borderColor")),
    borderLeftWidth: 0,
    borderRightWidth: 0
  }, (0, _defineProperty2["default"])(_ref3, "&[mdn-tab]:nth-child(".concat(selectedIndex, ")"), (0, _defineProperty2["default"])({
    marginInlineEnd: "".concat(-2 * t("borderWidth"), "px !important"),
    borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomRight"]),
    borderRightWidth: "".concat(t("borderWidth"), "px")
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomLeft"]),
    borderRightWidth: 0,
    borderLeftWidth: "".concat(t("borderWidth"), "px")
  })), (0, _defineProperty2["default"])(_ref3, "&[aria-selected='true'] + [mdn-tab]", (0, _defineProperty2["default"])({
    marginInlineStart: "".concat(-2 * t("borderWidth"), "px !important"),
    borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomLeft"]),
    borderLeftWidth: "".concat(t("borderWidth"), "px")
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomRight"]),
    borderLeftWidth: 0,
    borderRightWidth: "".concat(t("borderWidth"), "px")
  })), (0, _defineProperty2["default"])(_ref3, "&[aria-selected='true']", {
    borderColor: transparent
  }), (0, _defineProperty2["default"])(_ref3, "&[aria-selected='true']:before", {
    content: "\"\"",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: "".concat(t("borderWidth"), "px solid ").concat(t("borderColor")),
    borderBottomColor: transparent,
    borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["topLeft", "topRight"])
  }), (0, _defineProperty2["default"])(_ref3, ":not(:last-child)", {
    marginInlineEnd: 0
  }), (0, _defineProperty2["default"])(_ref3, "&:not([aria-selected='true']) > div", {
    opacity: 0
  }), (0, _defineProperty2["default"])(_ref3, "&:not([aria-selected='true']):hover > div", {
    opacity: !disabled ? 1 : undefined
  }), (0, _defineProperty2["default"])(_ref3, "padding", "".concat(t("spacingInsetVertical") + t("spacingInsetClassicVertical"), "px ").concat(t("spacingInsetHorizontal") + t("spacingInsetClassicHorizontal"), "px")), (0, _defineProperty2["default"])(_ref3, "marginBottom", 0), _ref3;
};

var tabBaseLineStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var selected = _ref4.selected,
      disabled = _ref4.disabled,
      type = _ref4.type;
  return (0, _emotion.css)({
    // This magic number for classic is used to make the appearance of internal padding
    // between the edge of the activated tab and the indicator bar. It's derived by
    // (target padding - existing padding) * 2 (sides)
    width: type === "classic" ? "calc(100% - ".concat((parseInt(t("spacingInsetClassicBaseLine")) - parseInt(t("spacingInsetClassicHorizontal"))) * 2, "px)") : "100%",
    height: t("indicatorHeight"),
    borderRadius: t("indicatorRadius"),
    margin: "auto",
    position: "absolute",
    left: 0,
    right: 0,
    bottom: type === "classic" ? 0 : -(t("indicatorHeight") + t("spacingVertical", type)),
    transition: t.transitionCss("motion", "background-color", "opacity"),
    backgroundColor: t("indicatorColor", disabled ? "disabled" : selected ? "selected" : "default"),
    "*:hover > &": (0, _emotion.css)(!disabled && {
      backgroundColor: t("indicatorColorHover")
    }),
    "*:active > &": (0, _emotion.css)(!disabled && {
      backgroundColor: t("indicatorColorPressed")
    })
  });
}, ["selected", "disabled", "type"]);
/**
 * Used to render a single tab in a group of tabs. Place this as a child of the
 * `TabGroup` component.
 */

var Tab = function Tab(props) {
  var children = props.children,
      disabled = props.disabled,
      value = props.value,
      id = props.id;

  var _useContext = (0, _react.useContext)(_context["default"]),
      t = _useContext.t,
      selectedValue = _useContext.value,
      selectedIndex = _useContext.selectedIndex,
      onChange = _useContext.onChange,
      type = _useContext.type,
      fill = _useContext.fill,
      onMoveFocus = _useContext.onMoveFocus;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var selected = value === selectedValue;

  var handleKeyDown = function handleKeyDown(event) {
    var key = event.key;

    if (key === "Home" || key === "End") {
      event.preventDefault();
    }

    if (keysThatMoveFocus.includes(key)) {
      onMoveFocus(key);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref5) {
    var focus = _ref5.focus,
        focusTrigger = _ref5.focusTrigger,
        focusProps = _ref5.focusProps;
    return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
      type: "button",
      className: styles(t, {
        selected: selected,
        disabled: disabled,
        fill: fill,
        type: type,
        selectedIndex: selectedIndex,
        focus: focus && focusTrigger === "keyboard"
      }),
      role: "tab",
      id: id,
      tabIndex: selected ? "0" : "-1",
      onClick: function onClick() {
        return onChange(value);
      },
      onKeyDown: handleKeyDown,
      "aria-selected": selected ? "true" : "false",
      disabled: disabled,
      "mdn-tab": "",
      "mdn-tab-value": value
    }, passThroughProps, focusProps), children, /*#__PURE__*/_react["default"].createElement("div", {
      className: tabBaseLineStyles(t, {
        selected: selected,
        disabled: disabled,
        type: type
      })
    }));
  });
};

Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The tab's label. Plain text (and optionally badges) recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The value of the tab. This is used by the parent `TabGroup` component to
   * track the selection of the tab.
   */
  value: _propTypes["default"].any.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the `role=tab` element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 6.2.0
   */
  id: _propTypes["default"].string
} : {};
var _default = Tab;
exports["default"] = _default;